import config from 'config/Config';

// 通过获取浏览器的 navigator.userAgent 来判断浏览器是否支持 webp 格式的图片；
// 该函数方法的缺陷是，如果用户修改了 navigator.userAgent 会导致判断出现不准确；
const browser_check_webp = (imageType) => {
  // 取得浏览器的 userAgent 字符串；
  let userAgent = navigator.userAgent;
  // 判断是否为 IE 版本小于 11 的浏览器；
  let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  // 判断是否为 IE11 浏览器；
  let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;

  if (isIE || isIE11) {
    // IE 浏览器，不支持 webp 格式的图片；
    return false;
  }

  // 注意：这种方法只是通过URL的后缀名来猜测图片类型，不一定准确。
  // 非 IE 浏览器，支持 webp 格式的图片；
  // 请求是否支持webp requestWepp定义在html
  // eslint-disable-next-line no-undef
  return true && requestWebp && imageType != 'png';
};

// 华为云处理图片函数
const obsProcessImg = (src, options = {}) => {
  let urlList = [
    'https://image-test.yofoto.cn',
    'https://image-uat.yofoto.cn',
    'https://image.yofogo.com'
  ];

  // 若不是华为云的图片，则不进行处理
  if (
    (!src.match(/\.obs\./) && !urlList.some((item) => src.indexOf(src) != -1)) ||
    src.indexOf('http') == -1
  ) {
    return src;
  }
  let processSrc = src;
  let { w = 0, h = 0, q = 0, m = 'lfit', custom = '' } = options;
  // 转换成数字
  w = +w;
  h = +h;
  q = +q;

  // 是否可以使用webp图片。目前只有chrome内核完美支持
  // const canUseWebp = !!navigator.userAgent.match(/chrome/gi);
  let imageType = '';
  try {
    imageType = processSrc.substring(processSrc.lastIndexOf('.') + 1);
  } catch (error) {}
  const canUseWebp = browser_check_webp(imageType);

  // 拼接处理函数 防重复处理
  if (processSrc.indexOf('?x-image-process=image/format,') == -1) {
    processSrc += `?x-image-process=image/format,${canUseWebp ? 'webp' : ['png', 'PNG'].includes(imageType) ? 'png' : 'jpg'}`;
  }
  // 拼接设置缩略的方法
  if (w || h) {
    if (w > 4096) {
      w = 4096;
    }
    if (h > 4096) {
      h = 4096;
    }
    // 拼接处理函数 防重复处理
    if (processSrc.indexOf('/resize,w_') == -1) {
      // limit_0会导致图片显著增大 且清晰度会有所下降
      // processSrc += `/resize,w_${w},h_${h},limit_0,m_${m}`;
      processSrc += `/resize,w_${w},h_${h},limit_0,m_${m}`;
    }
  }
  // 拼接设置质量的方法
  if (q && processSrc.indexOf('/quality,q_') == -1) {
    processSrc += `/quality,q_${q}`;
  }
  // 拼接自定义处理方式
  if (custom) {
    processSrc += custom;
  }

  return processSrc;
};

// 阿里云处理图片函数
const ossProcessImg = (src, options = {}) => {
  let processSrc = src;

  return processSrc;
};

/**
 *
 * @param {string} src 图片地址
 * @param {Object} options 图片处理相关入参
 * @param {boolean} options.process 是否进行图片处理，默认为true
 * @param {number} options.m 图片缩略模式，将设置图片以何种方式进行压缩。取值为lfit、mfit、fill、pad和fixed，默认值为lfit。
 *                           lfit：指定一个w和h的矩形，将图片进行等比缩放，取在矩形内最大的图片。
 *                           mfit：指定一个w和h的矩形，将图片进行等比缩放，取在矩形延伸区域的最小图片。
 *                           fill：指定一个w和h的矩形，将图片进行等比缩放，取在延伸区域的最小图片，并进行居中剪切。即将mfit缩略类型的图片进行居中剪裁。
 *                           pad：指定一个w和h的矩形，将图片进行等比缩放，取在矩形内最大的图片，并在矩形空白处进行颜色填充。即lfit缩略类型的图片在矩形空白处进行颜色填充。
 *                           fixed：强制按照固定的宽高进行缩略。
 * @param {number} options.w 图片宽度，[1，4096]
 * @param {number} options.h 图片高度，[1，4096]
 * @param {number} options.q 图片质量，[1,100]
 * @param {string} options.custom 根据对应云的文档进行自定义操作
 * 文档地址：https://blog.csdn.net/pk142536/article/details/99695234
 */
const processImg = (src, options) => {
  const { process = true } = options || {};

  const {
    custom: { thirdPartyCloud = 'obs' }
  } = config || {};

  // 不同云对应的图片处理函数.目前只对华为云做了处理
  const cloudEnum = {
    // 华为云
    obs: obsProcessImg,
    // 阿里云
    oss: ossProcessImg
  };

  if (!src) {
    return '';
  }
  if (!process) {
    return src;
  }
  return cloudEnum[thirdPartyCloud](src, options);
};

export { processImg };



// WEBPACK FOOTER //
// ./src/utils/processImg.js